//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'PostSocial',

	computed: {
		fullPath: function fullPath() {
			return this.$store.state.settings.siteRoot + this.$route.path;
		}
	},

	methods: {
		vkHandler: function vkHandler() {
			window.open('http://vk.com/share.php?url=' + this.fullPath, 'newwindow', 'width=500, height=450');
		},
		fbHandler: function fbHandler() {
			window.open('http://www.facebook.com/sharer/sharer.php?u=' + this.fullPath, 'newwindow', 'width=500, height=450');
		},
		okHandler: function okHandler() {
			window.open('https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=' + this.fullPath, 'newwindow', 'width=500, height=450');
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PostSocial.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/PostSocial.vue
// module chunks = 1 2